import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { LabelSelectorComponent } from './label-selector.component';

@NgModule({
  entryComponents: [
    LabelSelectorComponent
  ],
  declarations: [
    LabelSelectorComponent
  ],
  imports: [
    FuseSharedModule,
    MatIconModule,
    MatCheckboxModule,
    TranslateModule,
  ],
  exports: [
    LabelSelectorComponent
  ]
})
export class LabelSelectorModule { }
